import { Button } from 'components/universal/button';
import { HowToGetCertificate } from 'components/universal/howToGetCertificate';
import { Modal } from 'components/universal/modal';
import Paragraph from 'components/universal/paragraph';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { hideModal, showModal } from "store/modal/modalSlice";
import cls from './certificate.module.scss';


export const Certificate = () => {
    const { t } = useTranslation('', {
        keyPrefix: 'elearning.handHygiene.courseLayout.overview',
    });
    const dispatch = useDispatch();
    
    const hideModalHandle = () => {
        dispatch(hideModal());
    }

    const showPopup = () => {
        dispatch(showModal());
    }

    return (
        <div className={cls.certificate}>
            <Modal className={cls.modal}>
                <HowToGetCertificate onCancel={hideModalHandle} />
            </Modal>
            <Paragraph className={cls.text} fontWeight={700}>
                {t('claimedCertificate')}
            </Paragraph>
            <Button className={cls.btn} onClick={showPopup}>
                {t('downloadCertificate')}
            </Button>
        </div>
    );
};
